export const quickStatsCards = {
	student: {
		isLoading: true,
		show: true,
		iconClass: 'fa-child tw-text-[#BF272C]',
		statValue: 0,
		statDescription: 'Total Students',
	},
	assessments: {
		isLoading: true,
		show: true,
		iconClass: ' fa-child tw-text-[#57a445]',
		statValue: 0,
		statDescription: 'Total Assessments',
	},
	notAssessed: {
		isLoading: true,
		show: true,
		iconClass: 'fa-child tw-text-[#243670]',
		statValue: 0,
		statDescription: 'Unassessed Students',
	},
	phase1: {
		isLoading: true,
		show: true,
		iconImage: 'assets/img/1.png',
		iconClass: 'tw-fill-[#BB6362]',
		statValue: 0,
		statDescription: 'Students in Phase I',
	},
	phase2: {
		isLoading: true,
		show: true,
		iconImage: 'assets/img/2.png',
		statValue: 0,
		statDescription: 'Students in Phase II',
	},
	phase3: {
		isLoading: true,
		show: true,
		iconImage: 'assets/img/3.png',
		statValue: 0,
		statDescription: 'Students in Phase III',
	},
	complete: {
		isLoading: true,
		iconImage: 'assets/img/balloon_star.png',
		show: true,
		iconClass: '!tw-h-[60px] ',
		statValue: 0,
		statDescription: 'Students Complete',
	},
};

export const linkCards = [
	{
		url: '/dashboard',
		roles: ['Teacher'],
		iconClass: 'fa fa-user tw-text-6xl tw-mb-2 tw-text-[#243670]',
		title: 'Enter Scores',
		description: 'Enter Assessment Scores',
	},
	{
		url: '/teacher',
		roles: ['Teacher'],
		iconClass: 'fa fa-line-chart tw-text-6xl tw-mb-2 tw-text-[#243670]',
		title: 'Progress',
		description: 'How your students are doing',
	},
	{
		url: 'https://support.confidentlearners.com/hc/en-ca',
		iconClass: 'fa fa-book tw-text-6xl tw-mb-2 tw-text-[#243670]',
		roles: ['Teacher', 'Principal', 'Area', 'AdminLite', 'Admin'],
		title: 'Knowledge Base',
		description: 'Articles',
	},
	{
		url: 'https://academy.confidentlearners.com/',
		iconClass: 'fa fa-graduation-cap tw-text-6xl tw-mb-2 tw-text-[#243670]',
		roles: ['Teacher', 'Principal', 'Area', 'AdminLite', 'Admin'],
		title: 'LMS',
		description: 'Visit Learning Management System',
	},
	{
		url: 'https://thelearningbar.com/',
		iconImage: '../../assets/img/tlb-logo-60.png',
		roles: ['Teacher', 'Principal', 'Area', 'AdminLite', 'Admin'],
		title: 'The Learning Bar',
		description: 'Visit Learning Management System',
	},
];
